export const formatStoreName = (...stores) => {
  const line1 = stores.reduce(
    (acc, store) => acc || store?.commonInfo?.address?.line1,
    '',
  );
  const city = stores.reduce(
    (acc, store) => acc || store?.commonInfo?.address?.city,
    '',
  );
  const province = stores.reduce(
    (acc, store) => acc || store?.commonInfo?.address?.province,
    '',
  );
  const postalCode = stores.reduce(
    (acc, store) => acc || store?.commonInfo?.address?.postalCode,
    '',
  );
  let value = '';
  if (line1) value += `${line1}, `;
  if (city) value += `${city}, `;
  if (province) value += `${province} `;
  if (postalCode) value += postalCode;
  return value;
};
